import {
  ADD_EDUCATION,
  ADD_LOCATION,
  ADD_CAMPUS,
  ADD_TERMS,
  ADD_SCORE,
  SET_IMAGE_PAIRS,
  SAVE_REGISTRATION_SOURCE,
  SET_PRE_REGISTRATION_FLAG,
  SET_REGISTER_OPTIONS,
  GET_TOP_MATCHES,
  USER_LOGOUT_PREREGISTRATION,
  REGISTRATION_COMPLETE,
} from '../actionTypes';

const getInitialState = () => ({
  education: {},
  country: '',
  territory: '',
  campusId: '',
  agreedToTerms: false,
  termsVersionNumber: 0,
  score: {},
  imagePairs: [],
  registrationSource: null,
  // DEV NOTE: This flag is different from registrationInProcess and is used to make sure all potential \
  // user data has been retrieved from our DB after any type of auth event so they are correctly routed \
  // to the appropriate page and place within the app
  preregistrationFlag: false,
  registerOptionsValue: null,
  topThreeMatches: [],
});

export default function (state = getInitialState(), action) {
  switch (action.type) {
    case ADD_EDUCATION: {
      const { educationLevel } = action.payload; // e.g. "some college"

      return {
        ...state,
        education: educationLevel,
      };
    }
    case ADD_LOCATION: {
      const { country, territory } = action.payload;

      return {
        ...state,
        country,
        territory,
      };
    }
    case ADD_CAMPUS: {
      return {
        ...state,
        campusId: action.payload,
      };
    }
    case ADD_TERMS: {
      const { agreedToTerms, termsVersionNumber } = action.payload;

      return {
        ...state,
        agreedToTerms,
        termsVersionNumber,
      };
    }
    case ADD_SCORE: {
      const { results } = action.payload;

      return {
        ...state,
        score: results,
      };
    }
    case SET_IMAGE_PAIRS: {
      const { imagePairs } = action.payload;

      return {
        ...state,
        imagePairs,
      };
    }
    case SAVE_REGISTRATION_SOURCE: {
      const { registrationSource } = action.payload;

      return {
        ...state,
        registrationSource,
      };
    }
    case SET_PRE_REGISTRATION_FLAG: {
      const { value } = action.payload;

      return {
        ...state,
        preregistrationFlag: value,
      };
    }
    case SET_REGISTER_OPTIONS: {
      const { value } = action.payload;

      return {
        ...state,
        registerOptionsValue: value,
      };
    }
    case GET_TOP_MATCHES: {
      const { topThreeMatches } = action.payload;

      return {
        ...state,
        topThreeMatches,
      };
    }
    case USER_LOGOUT_PREREGISTRATION: {
      return getInitialState();
    }
    case REGISTRATION_COMPLETE: {
      return getInitialState();
    }
    default:
      return state;
  }
}
